import { render, staticRenderFns } from "./DirectionComparisonPanel.vue?vue&type=template&id=896e4fb0&"
import script from "./DirectionComparisonPanel.vue?vue&type=script&lang=js&"
export * from "./DirectionComparisonPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports